import { LoginProvider } from "../login/context/LoginContext";
import LoginPopup from "../login/LoginPopup";

export default function LoginWrapper({children}) {
    return <LoginProvider>
        <LoginPopup>{children}</LoginPopup>
    </LoginProvider>
}
